export const toggleSwitchSx = (theme) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.tertiary.main,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.tertiary.main,
  },
});
